// extracted by mini-css-extract-plugin
module.exports = {"tags":"ArticleInfo_tags___rs3q","tag":"ArticleInfo_tag__s3E_f","time":"ArticleInfo_time___70Yn"};